export var DateFormatPatterns;
(function (DateFormatPatterns) {
    DateFormatPatterns["shortMonthDayYear"] = "MMM dd, yyyy";
    DateFormatPatterns["fullMonthDayYear"] = "MMMM dd, yyyy";
    DateFormatPatterns["fullMonthDayYearAlt"] = "dd MMMM, yyyy";
    DateFormatPatterns["shortMonthDayYearAlt"] = "dd MMM yyyy";
    DateFormatPatterns["fullMonthDay"] = "MMMM dd";
    DateFormatPatterns["fullMonthYear"] = "MMMM yyyy";
    DateFormatPatterns["smallDateWithLocalTime"] = "MMM dd - t";
    DateFormatPatterns["shortDateWithSlash"] = "MM/dd/yyyy";
    DateFormatPatterns["shortDateWithSlashAlt"] = "M/d/yyyy";
    DateFormatPatterns["shortDateWithDash"] = "yyyy-MM-dd";
    DateFormatPatterns["fullDateStartsFromMonth"] = "MMM. dd, yyyy";
    DateFormatPatterns["fullDateWithTime"] = "MM/dd/yyyy hh:mm a";
    DateFormatPatterns["meridiemTimePadded"] = "hh:mm a";
    DateFormatPatterns["meridiemTimeWithSecondsPadded"] = "hh:mm:ss a";
    DateFormatPatterns["meridiemTimePaddedWithDate"] = "hh:mm a MM/dd/yyyy";
    DateFormatPatterns["monthDayYearDashes"] = "MM-dd-yy";
    DateFormatPatterns["monthDayFullYearDashes"] = "MM-dd-yyyy";
    DateFormatPatterns["monthDayDots"] = "MM.dd";
    DateFormatPatterns["shortMonthDayDots"] = "M.d";
    DateFormatPatterns["monthDayYearDots"] = "MM.dd.yy";
    DateFormatPatterns["monthDayFullYearDots"] = "MM.dd.yyyy";
    DateFormatPatterns["monthDayYearSlashes"] = "MM/dd/yy";
    DateFormatPatterns["monthDaySlashes"] = "MM/dd";
    DateFormatPatterns["shortMonthDaySlashes"] = "M/d";
    DateFormatPatterns["monthDay"] = "MMdd";
    DateFormatPatterns["shortMonthDayShortYear"] = "M.dd.yy";
    DateFormatPatterns["monthShortDayShortYear"] = "MM.d.yy";
    DateFormatPatterns["shortMonthShortDayShortYear"] = "M.d.yy";
    DateFormatPatterns["shortMonthDayFullYear"] = "M.dd.yyyy";
    DateFormatPatterns["monthShortDayFullYear"] = "MM.d.yyyy";
    DateFormatPatterns["shortMonthShortDayFullYear"] = "M.d.yyyy";
    DateFormatPatterns["shortMonthDayShortYearSlashes"] = "M/dd/yy";
    DateFormatPatterns["monthShortDayShortYearSlashes"] = "MM/d/yy";
    DateFormatPatterns["shortMonthShortDayShortYearSlashes"] = "M/d/yy";
    DateFormatPatterns["shortMonthDayFullYearSlashes"] = "M/dd/yyyy";
    DateFormatPatterns["monthShortDayFullYearSlashes"] = "MM/d/yyyy";
    DateFormatPatterns["shortMonthDayShortYearDashes"] = "M-dd-yy";
    DateFormatPatterns["monthShortDayShortYearDashes"] = "MM-d-yy";
    DateFormatPatterns["shortMonthShortDayShortYearDashes"] = "M-d-yy";
    DateFormatPatterns["shortMonthDayFullYearDashes"] = "M-dd-yyyy";
    DateFormatPatterns["monthShortDayFullYearDashes"] = "MM-d-yyyy";
    DateFormatPatterns["shortMonthShortDayFullYearDashes"] = "M-d-yyyy";
})(DateFormatPatterns || (DateFormatPatterns = {}));
export const Locale = {
    US: 'en-US',
    SE: 'sv-SE', // Short date with dash (yyyy-MM-dd). Required by 8Base
};
export const DEFAULT_DATE_FORMAT = DateFormatPatterns.shortDateWithSlash;
export const ALLOWED_EXCEL_DATE_FORMATS = [
    DateFormatPatterns.fullMonthDayYear,
    DateFormatPatterns.fullMonthDayYearAlt,
    DateFormatPatterns.fullDateStartsFromMonth,
    DateFormatPatterns.shortDateWithDash,
    DateFormatPatterns.shortDateWithSlash,
    DateFormatPatterns.shortDateWithSlashAlt,
    DateFormatPatterns.monthDayYearSlashes,
    DateFormatPatterns.monthDayFullYearDots,
    DateFormatPatterns.monthDayYearDots,
    DateFormatPatterns.monthDayFullYearDashes,
    DateFormatPatterns.monthDayYearDashes,
    DateFormatPatterns.shortMonthDayShortYear,
    DateFormatPatterns.monthShortDayShortYear,
    DateFormatPatterns.shortMonthShortDayShortYear,
    DateFormatPatterns.shortMonthDayFullYear,
    DateFormatPatterns.monthShortDayFullYear,
    DateFormatPatterns.shortMonthShortDayFullYear,
    DateFormatPatterns.shortMonthDayShortYearSlashes,
    DateFormatPatterns.monthShortDayShortYearSlashes,
    DateFormatPatterns.shortMonthShortDayShortYearSlashes,
    DateFormatPatterns.shortMonthDayFullYearSlashes,
    DateFormatPatterns.monthShortDayFullYearSlashes,
    DateFormatPatterns.shortMonthDayShortYearDashes,
    DateFormatPatterns.monthShortDayShortYearDashes,
    DateFormatPatterns.shortMonthShortDayShortYearDashes,
    DateFormatPatterns.shortMonthDayFullYearDashes,
    DateFormatPatterns.monthShortDayFullYearDashes,
    DateFormatPatterns.shortMonthShortDayFullYearDashes,
];
//# sourceMappingURL=date.js.map